import { useEffect, useState } from 'react';
import './test-page.css';

const MIN_HEIGHT = 900;

export default function TestPage() {
  const [height, setHeight] = useState(MIN_HEIGHT);

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (event.data?.source !== 'getstarted-embed') return;
      setHeight(Math.max(MIN_HEIGHT, Number(event.data.height) || MIN_HEIGHT));
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return (
    <div className="test-page">
      <h1>TEST PAGE</h1>
      <iframe
        src="https://dev.get-started.trailersolutionsfl.com/embed/id/439"
        title="Embedded Content"
        className="test-page-iframe"
        style={{ height }}
      />
    </div>
  );
}
